<template>
  <div class="question-page">
    <div class="sidebar">
      <div class="wrapper">
        <div style="font-weight: bold; margin-bottom: 10px; color:#04b2c5;padding-bottom:10px;border-bottom:1px solid #ddd;text-align: center;">{{ exam.questions.length }} Questions</div>
  
        <div
          v-for="(e, index) in exam.questions"
          :class="index == questionId ? 'q-title active' : 'q-title'"
          @click="loadQuestion(e, index)">
          <span>Question {{ index + 1 }}</span>
          <!-- <span class="badge badge-secondary" style="margin-left: 10px" v-if="getStatus(index) == -1" type="secondary">TODO</span> -->
          <span class="badge badge-success" style="margin-left: 10px" v-if="getStatus(index) == 1" type="success">CORRECT</span>
          <span class="badge badge-danger" style="margin-left: 10px" v-if="getStatus(index) == 0" type="warning">WRONG</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="wrapper">
        <div style="font-weight: bold;margin-bottom:10px;color:#04b2c5;padding-bottom:10px;border-bottom:1px solid #ddd">
          Question {{ questionId + 1 }}
          <span class="badge badge-warning" v-for="t in question.tags" style="margin: 0px 5px;">{{ t.tag_name }}</span>
          <span class="badge badge-info" style="float:right;margin-top:0px;cursor: pointer;padding-top:0.5rem;padding-bottom:0.5rem" @click="cancelFav(question)" v-if="isFav"><i class="fas fa-star"></i> 取消收藏</span>
          <span class="badge badge-info" style="float:right;margin-top:0px;cursor: pointer;padding-top:0.5rem;padding-bottom:0.5rem" @click="addTofav(question)" v-if="!isFav"><i class="far fa-star"></i> 收藏题目</span>
        </div>
        <div v-html="question.question" style="text-align: left;"></div>
        
        
      </div>
    </div>
    <div class="operation">
      <div class="wrapper">
        <div style="text-align: left;">
          <div style="font-weight: bold; margin-bottom: 10px; color:#04b2c5;padding-bottom:10px;border-bottom:1px solid #ddd;">Please Click to Select your answer
          
            <span class="badge badge-info" style="float:right;margin-top:0px;cursor: pointer;padding-top:0.5rem;padding-bottom:0.5rem" id="drawerToggle" @click="openDrawer"><i class="fas fa-info-circle"></i> 查看解析</span>
          </div>
          <div
            v-for="(o, index1) in question.options"
            :class="index1 == optionId ? (getStatus(questionId) == 1 ? 'option active correct' : 'option active wrong') : 'option'"
            @click="setAnswer(question.id, index1)"
          >
            <div style="margin-right: 10px;"><span class="badge badge-dark">{{getAlpha(index1) }}</span> </div>
            <div v-html="o"></div>
          </div>
        </div>
        <!-- <div v-html="question.analysis"></div> -->
      </div>
    </div>


    <div id="drawer" class="drawer">
        <div class="drawer-content">
          <div style="height:60px;">&nbsp;</div>
          <div>
            <div style="font-weight: bold; margin-bottom: 10px; color:#04b2c5;padding-bottom:10px;border-bottom:1px solid #ddd;font-size: 16px;">Question Analysis
            </div>
          </div>
          <div v-html="question.analysis"></div>
        </div>
    </div>
    <div id="overlay" class="overlay" @click="closeDrawer"></div>
  </div>
</template>

<script>

import axios from 'axios';
import util from '@/utils/util';
export default {
  
  data() {
    return {
      question: {},
      questionId: 0,
      optionId: -1,
      map: new Map(),
      exam: {},
      favorite: [],
      userInfo:{}
    };
  },
  computed:{
    isFav(){
      
      var questionId = this.question.id;
      if(!questionId){
        return false;
      }
      
      var filterR = this.favorite.filter( r=> r == questionId);
      return filterR.length >0;
      
    }
  },
  mounted(){
    var user = localStorage.getItem('user');
    if(user && user != null && user != ''){
            var userObj = JSON.parse(user);
           this.userInfo = userObj;
        }
        else{
            location.href = '/';
            return;
        }

        this.loadFav();

        var id = util.getSearchString("id");
        if(id == 1){
          axios.get('https://apapi.dctechonline.cn/api/daily/unlimited/10').then(response => {
              var obj = {};
              obj.name = '每日练习';
              obj.questions = response.data;
            
              this.exam = obj;

              this.loadQuestion(this.exam.questions[0], 0);
          }).catch(error => {
            console.error('Error fetching data:', error);
          });
        }
        else if(id == 2){
          axios.get('https://apapi.dctechonline.cn/api/favorite/'+this.userInfo.UserId+'/0').then(response => {
              var obj = {};
              obj.name = '收藏反复练';
              obj.questions = response.data;
            
              this.exam = obj;
              this.loadQuestion(this.exam.questions[0], 0);
          }).catch(error => {
            console.error('Error fetching data:', error);
          });
        }
        else if(id ==3){
          var tagId = util.getSearchString("tag");
          axios.get(`https://apapi.dctechonline.cn/api/tag/${tagId}/0`).then(response => {
              var obj = {};
              obj.name = '专项练习';
              obj.questions = response.data;
            
             this.exam= obj;
             this.loadQuestion(this.exam.questions[0], 0);
          }).catch(error => {
            console.error('Error fetching data:', error);
          });
        }
    

    
  },
  methods: {
    async loadFav(){
      try {
        const userId = this.userInfo.UserId;
        const response = await axios.get(`https://apapi.dctechonline.cn/api/favorite/${userId}/0`);
        this.favorite = [];
        response.data.forEach( r=>{
            this.favorite.push(r.id);
        })
      } catch (err) {
        
      }
    },
    closeDrawer(){
      $('#drawer').removeClass('open');
                $('#overlay').removeClass('open');
    },
    openDrawer(){
      $('#drawer').toggleClass('open');
                $('#overlay').toggleClass('open');
    },
    setAnswer(id, a) {
      this.map.set(id, a);
      this.optionId = a;
      this.question = { ...this.question };
    },
    isFav(question){
      var questionId = question.Id;
      if(questionId){
      var filterR = this.favorite.filter( r=> r.Id = questionId);
      return filterR.length >0;
      }
      else{
        return false;
      }
    },
    getStatus(index) {
      if (this.map.has(this.exam.questions[index].id)) {
        const ans = this.exam.questions[index].answer[0];
        if (ans == this.map.get(this.exam.questions[index].id)) {
          return 1;
        } else {
          return 0;
        }
      } else {
        return -1;
      }
    },
    addTofav(question){
      const id = question.id;
      const userId = this.userInfo.UserId;

      this.$http.post('https://apapi.dctechonline.cn/api/favorite', {
        questionId: id,
        userId: userId
      }).then(response => {
        this.loadFav();
      });
    },
    cancelFav(question){
      const id = question.id;
      const userId = this.userInfo.UserId;
      this.$http.delete(`https://apapi.dctechonline.cn/api/favorite/${userId}/${id}`).then(response => {
        this.loadFav();
      });
    },
    loadQuestion(q, index) {
      axios.get(`https://apapi.dctechonline.cn/api/question/${q.id}`).then((response) => {
        this.question = response.data;
        this.questionId = index;
        if (this.map.has(this.exam.questions[this.questionId].id)) {
          this.optionId = this.map.get(this.exam.questions[this.questionId].id);
        } else {
          this.optionId = -1;
        }
      });
    },
    getAlpha(index) {
      switch (index) {
        case 0:
          return 'A';
        case 1:
          return 'B';
        case 2:
          return 'C';
        case 3:
          return 'D';
        case 4:
          return 'E';
        default:
          return '';
      }
    },
  }
};
</script>

<style>
.question-page {
  position: fixed;
  left: 0;
  top: 55px;
  width: 100%;
  height: calc(100% - 55px);
  display: flex;
  background: #eee;
}

.sidebar {
  width: 240px;
  height: 100%;
}

.sidebar .wrapper {
  background: white;
  margin: 15px;
  height: calc(100% - 30px);
  width: calc(100% - 30px);
  text-align: left;
  padding: 10px 10px;
  overflow: auto;
  border-radius: 10px;
}

.content .wrapper {
  background: white;
  margin: 15px 0px;
  height: calc(100% - 30px);
  width:100%;
  padding: 10px 15px;
  overflow: auto;
  border-radius: 10px;
}

.sidebar .q-title {
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  text-align: center;
  border:1px solid #f5f5f5;
  margin-bottom: 5px;
}

.sidebar .q-title.active {
  background: #04b2c5;
  color:white;
  border-radius: 5px;
}

.sidebar .q-title:hover {
  background: rgb(225, 243, 249);
  color:#333;
  cursor: pointer;
}

.content {
  height: 100%;
  color: #000;
  width: calc(100% - 740px);
  line-height:25px;
}

.operation {
  width: 500px;
  height: 100%;
  line-height:25px;
}

.option {
  display: flex;
  line-height: 30px;
  cursor: pointer;
  color:#666;
  padding:5px 10px;
  border-radius: 3px;
  border:1px solid #f5f5f5;
  margin-bottom: 5px;
}

.option.active.correct {
  background: #28a745;
  border-radius: 3px;
  color:white;
}

.option.active code{
  color:white;
}

.option.active.wrong {
  background: #dc3545;
  color: white;
  border-radius: 3px;
}

.option:hover {
  background: rgb(225, 243, 249);
}

.operation .wrapper {
  background: white;
  margin: 15px 15px;
  height: calc(100% - 30px);
  width: calc(100% - 30px);
  padding: 10px 15px;
  overflow: auto;
  border-radius: 10px;
  
}

pre{
  border-radius: 3px;
  color: #fff;
  background:#333;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  padding:5px 10px;
  line-height:25px;
}

code {
  color: #333;
}

table {
  border-collapse: collapse;
}


.drawer {
            position: fixed;
            top: 0;
            right: -400px;
            width: 400px;
            max-width: 100%;
            height: 100%;
            background-color: #f8f9fa;
            transition: right 0.3s ease-in-out;
            z-index: 1000;
            overflow: auto;
        }

        .drawer.open {
            right: 0;
        }

        .drawer-content {
            padding: 20px;
            font-size:14px;
        }

        .drawer p{
            font-size: 14px;
        }

        .overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 999;
            display: none;
        }

        .overlay.open {
            display: block;
        }
</style>